import React from 'react';

import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import SimpleSlider from '../slider/';

import './style.sass';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';
import CommonOlList from '../../../common-components/common-ol-list';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonCollapseItem from '../../../common-components/common-collapse-item';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';

const firstItemList = {
    colorNumber: '#00529d',
    list: [
        'Логотип,',
        'Цветовая палитра,',
        'Шрифтовые гарнитуры,',
        'Деловая документация,',
        'Корпоративная презентация.',
    ],
};

const secondItemList = {
    colorNumber: '#00529d',
    list: [
        'Скорость загрузки 2,4&nbsp;сек. Что на&nbsp;50% меньше рекомендуемого компанией Google;',
        'Отсутствие адаптивных версий сайта под мобильные и&nbsp;планшетные устройства. Это означает, что более 53,5% месячной аудитории пользователей не&nbsp;могут полноценно взаимодействовать с&nbsp;сайтом;',
        'Мелкий шрифт, наличие 2-х колонок в&nbsp;тексте, а&nbsp;также отсутствие иерархии заголовков&nbsp;&mdash; все это негативно влияет на&nbsp;восприятие текста и&nbsp;желание пользователя изучать информацию и&nbsp;узнавать больше о&nbsp;деятельности Фонда ЖКХ.',
    ],
};

const thirdItemList = [
    {
        title: 'Собрали семантическое ядро',
        subtitle:
            'Подобрали расширенную группу ключевых слов, проверили их&nbsp;на&nbsp;частоту использования, сформировали семантические группы, сопоставили группы ключевых слов и&nbsp;страницы сайта.',
    },
    {
        title: 'Провели техническую оптимизацию сайта',
        subtitle:
            'Зарегистрировали сайт в&nbsp;сервисах для вебмастеров Яндекс и&nbsp;Google, установили и&nbsp;настроили Яндекс.Метрику и&nbsp;Google Analytics, проверили корректность файла robots.txt, наличие файла sitemap.xml, корректность кодов ответа сервера, региональной привязки сайта и&nbsp;дубли страниц, а&nbsp;также наличие санкций со&nbsp;стороны поисковых систем.',
    },
    {
        title: 'Оптимизировали тексты и&nbsp;коды сайта',
        subtitle:
            'Оптимизировали код сайта посадочных страниц по&nbsp;списку ключевых слов, проверили тексты на&nbsp;уникальность и&nbsp;составили рекомендации по&nbsp;их&nbsp;улучшению, реализовали внутреннюю схему перелинковки страниц, создали карты 403-редиректов при переходе к&nbsp;новой версии сайта.',
    },
];

const fourthItemList = {
    colorNumber: '#00529d',
    list: [
        'Версия CMS клиента была достаточно новой, но&nbsp;не&nbsp;последней;',
        'На&nbsp;сервере PHP версии 7.0.3. Это старая версия интерпретатора языка программирования, которую официальное сообщество не&nbsp;поддерживает с&nbsp;2019 года;',
        'Если обновить PHP, текущая версия CMS будет работать с&nbsp;ошибками;',
        'Анализ исходного кода сайта показал, что сайт развивался хаотично и&nbsp;бессистемно.',
    ],
};

const fifthItemList = {
    colorNumber: '#00529d',
    list: [
        'Разработали стилистику всех типовых презентаций для фонда ЖКХ',
        'Составили 13&nbsp;презентаций по&nbsp;ключевым направлений работы Фонда',
        'Подготовили 22&nbsp;инфографика, отражающих основные результаты работы Фонда',
    ],
};

const firstSlider = [
    { img: '/images/pic/zkhfoundation/guide1.jpg' },
    { img: '/images/pic/zkhfoundation/guide2.jpg' },
    { img: '/images/pic/zkhfoundation/guide3.jpg' },
    { img: '/images/pic/zkhfoundation/guide4.jpg' },
    { img: '/images/pic/zkhfoundation/guide5.jpg' },
    { img: '/images/pic/zkhfoundation/guide6.jpg' },
    { img: '/images/pic/zkhfoundation/guide7.jpg' },
    { img: '/images/pic/zkhfoundation/guide8.jpg' },
    { img: '/images/pic/zkhfoundation/guide9.jpg' },
    { img: '/images/pic/zkhfoundation/guide10.jpg' },
    { img: '/images/pic/zkhfoundation/guide11.jpg' },
    { img: '/images/pic/zkhfoundation/guide12.jpg' },
    { img: '/images/pic/zkhfoundation/guide13.jpg' },
    { img: '/images/pic/zkhfoundation/guide14.jpg' },
    { img: '/images/pic/zkhfoundation/guide15.jpg' },
    { img: '/images/pic/zkhfoundation/guide16.jpg' },
    { img: '/images/pic/zkhfoundation/guide17.jpg' },
    { img: '/images/pic/zkhfoundation/guide18.jpg' },
    { img: '/images/pic/zkhfoundation/guide19.jpg' },
    { img: '/images/pic/zkhfoundation/guide20.jpg' },
    { img: '/images/pic/zkhfoundation/guide21.jpg' },
    { img: '/images/pic/zkhfoundation/guide22.jpg' },
    { img: '/images/pic/zkhfoundation/guide23.jpg' },
    { img: '/images/pic/zkhfoundation/guide24.jpg' },
    { img: '/images/pic/zkhfoundation/guide25.jpg' },
    { img: '/images/pic/zkhfoundation/guide26.jpg' },
    { img: '/images/pic/zkhfoundation/guide27.jpg' },
    { img: '/images/pic/zkhfoundation/guide28.jpg' },
    { img: '/images/pic/zkhfoundation/guide29.jpg' },
    { img: '/images/pic/zkhfoundation/guide30.jpg' },
    { img: '/images/pic/zkhfoundation/guide31.jpg' },
    { img: '/images/pic/zkhfoundation/guide32.jpg' },
    { img: '/images/pic/zkhfoundation/guide33.jpg' },
    { img: '/images/pic/zkhfoundation/guide34.jpg' },
    { img: '/images/pic/zkhfoundation/guide35.jpg' },
    { img: '/images/pic/zkhfoundation/guide36.jpg' },
    { img: '/images/pic/zkhfoundation/guide37.jpg' },
    { img: '/images/pic/zkhfoundation/guide38.jpg' },
    { img: '/images/pic/zkhfoundation/guide39.jpg' },
    { img: '/images/pic/zkhfoundation/guide40.jpg' },
    { img: '/images/pic/zkhfoundation/guide41.jpg' },
    { img: '/images/pic/zkhfoundation/guide42.jpg' },
];

const secondSlider = [
    { img: '/images/pic/zkhfoundation/Artboard.jpg' },
    { img: '/images/pic/zkhfoundation/Artboard Copy.jpg' },
    { img: '/images/pic/zkhfoundation/Artboard Copy 2.jpg' },
    { img: '/images/pic/zkhfoundation/Artboard Copy 3.jpg' },
    { img: '/images/pic/zkhfoundation/Artboard Copy 4.jpg' },
    { img: '/images/pic/zkhfoundation/Artboard Copy 5.jpg' },
    { img: '/images/pic/zkhfoundation/Artboard Copy 6.jpg' },
    { img: '/images/pic/zkhfoundation/Artboard Copy 7.jpg' },
    { img: '/images/pic/zkhfoundation/Artboard Copy 8.jpg' },
    { img: '/images/pic/zkhfoundation/Artboard Copy 9.jpg' },
    { img: '/images/pic/zkhfoundation/Artboard Copy 10.jpg' },
    { img: '/images/pic/zkhfoundation/Artboard Copy 11.jpg' },
    { img: '/images/pic/zkhfoundation/Artboard Copy 12.jpg' },
    { img: '/images/pic/zkhfoundation/Artboard Copy 13.jpg' },
    { img: '/images/pic/zkhfoundation/Artboard Copy 14.jpg' },
    { img: '/images/pic/zkhfoundation/Artboard Copy 15.jpg' },
];

const Process = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper bigPaddings={true} caseName="zkhfoundation-process">
                <CommonTitle>Процесс</CommonTitle>

                <CommonUsualText className="zkhfoundation-process__title">
                    Чтобы привлечь внимание к&nbsp;работе Фонда и&nbsp;показать основные
                    направления, мы&nbsp;провели комплексную работу:
                </CommonUsualText>

                <div className="zkhfoundation-process__container">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="zkhfoundation-process__item"
                    >
                        <div className="zkhfoundation-process__item-slider">
                            <SimpleSlider info={firstSlider} />
                        </div>
                        <div className="zkhfoundation-process__item-info">
                            <CommonSmallTitle className="zkhfoundation-process__item-title">
                                01. Собрали брендбук
                            </CommonSmallTitle>
                            <CommonSmallText className="zkhfoundation-process__item-text">
                                Разработали варианты начертания логотипа с&nbsp;разным видом
                                названия Фонда содействия реформированию ЖКХ и&nbsp;собрали
                                брендбук, в&nbsp;который вошли:
                            </CommonSmallText>
                            <CommonOlList
                                className="zkhfoundation-process__item-list"
                                CommonOlList={firstItemList}
                            />
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="zkhfoundation-process__item zkhfoundation-process__item--reverse"
                    >
                        <div className="zkhfoundation-process__item-img">
                            <img
                                src="/images/pic/zkhfoundation/im-gs-02.png"
                                alt="Провели аудит"
                                title="Провели аудит"
                                loading="lazy"
                            />
                        </div>
                        <div className="zkhfoundation-process__item-info">
                            <CommonSmallTitle className="zkhfoundation-process__item-title">
                                02. Провели аудит
                            </CommonSmallTitle>
                            <CommonSmallText className="zkhfoundation-process__item-text">
                                Провели аудит текущего сайта фонда на&nbsp;юзабилити и&nbsp;выявили
                                проблемы, которые исправили на&nbsp;этапе редизайна
                                и&nbsp;разработки:
                            </CommonSmallText>
                            <CommonOlList
                                className="zkhfoundation-process__item-list"
                                CommonOlList={secondItemList}
                            />
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="zkhfoundation-process__item"
                    >
                        <div className="zkhfoundation-process__item-img">
                            <img
                                src="/images/pic/zkhfoundation/im-gs-03.png"
                                alt="Поисковая оптимизация"
                                title="Поисковая оптимизация"
                                loading="lazy"
                            />
                        </div>
                        <div className="zkhfoundation-process__item-info">
                            <CommonSmallTitle className="zkhfoundation-process__item-title">
                                03. Поисковая оптимизация
                            </CommonSmallTitle>
                            <CommonSmallText className="zkhfoundation-process__item-text">
                                Провели работы по&nbsp;базовой поисковой оптимизации
                                на&nbsp;обновленном сайте Фонда:
                            </CommonSmallText>
                            {thirdItemList.map(({ title, subtitle }, index) => (
                                <CommonCollapseItem
                                    index={++index}
                                    triggerText={title}
                                    content={parse(subtitle)}
                                    classParent={'zkhfoundation-process__collapse-item'}
                                    numberColor={'#00529d'}
                                    key={++index}
                                />
                            ))}
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="zkhfoundation-process__item zkhfoundation-process__item--reverse"
                    >
                        <div className="zkhfoundation-process__item-img">
                            <img
                                src="/images/pic/zkhfoundation/im-gs-04.png"
                                alt="Замена CMS"
                                title="Замена CMS"
                                loading="lazy"
                            />
                        </div>
                        <div className="zkhfoundation-process__item-info">
                            <CommonSmallTitle className="zkhfoundation-process__item-title">
                                04. Замена CMS
                            </CommonSmallTitle>
                            <CommonSmallText className="zkhfoundation-process__item-text">
                                Перевели клиента на&nbsp;другую CMS и&nbsp;полностью переписали
                                frontend и&nbsp;backend сайта, потому что:
                            </CommonSmallText>
                            <CommonOlList
                                className="zkhfoundation-process__item-list"
                                CommonOlList={fourthItemList}
                            />
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="zkhfoundation-process__item"
                    >
                        <div className="zkhfoundation-process__item-slider">
                            <SimpleSlider info={secondSlider} />
                        </div>
                        <div className="zkhfoundation-process__item-info">
                            <CommonSmallTitle className="zkhfoundation-process__item-title">
                                05. Инфографика
                            </CommonSmallTitle>
                            <CommonSmallText className="zkhfoundation-process__item-text">
                                Разработали типовые презентации и&nbsp;инфографики:
                            </CommonSmallText>
                            <CommonOlList
                                className="zkhfoundation-process__item-list"
                                CommonOlList={fifthItemList}
                            />
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="zkhfoundation-process__item zkhfoundation-process__item--reverse"
                    >
                        <div className="zkhfoundation-process__item-video">
                            <iframe
                                title="Видео"
                                width="100%"
                                height="315"
                                src="https://www.youtube.com/embed/jmuV5emWN_Q"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                        <div className="zkhfoundation-process__item-info">
                            <CommonSmallTitle className="zkhfoundation-process__item-title">
                                06. Видео
                            </CommonSmallTitle>
                            <CommonSmallText className="zkhfoundation-process__item-text">
                                Создали видеоролик, в&nbsp;котором наглядно показываются работы
                                по&nbsp;программе финансовой поддержки энергоэффективного
                                капремонта.
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Process;
